import { BorderOutlined, PushpinOutlined } from '@ant-design/icons';
import { EnumTagSemanticoDTOTipo } from '@framework/api-client';
import { TagSemanticoDTO } from '@framework/api-client/src/api/backoffice/schemas';
import { Datatype, DatatypeIcon, assertNever } from '@framework/engine';
import { Space } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';

const SemanticTagBadgeSpace = styled(Space)`
  border-radius: 4px;
  padding: 0px 6px;
  max-height: 26px;
`;

function mapSemanticTagType(
  semanticTagType: EnumTagSemanticoDTOTipo | null | undefined,
) {
  if (!semanticTagType) return null;
  if (semanticTagType === EnumTagSemanticoDTOTipo.GEOMETRY) return 'geometry';

  switch (semanticTagType) {
    case EnumTagSemanticoDTOTipo.BOOLEAN:
      return Datatype.Boolean;
    case EnumTagSemanticoDTOTipo.DATE:
      return Datatype.Date;
    case EnumTagSemanticoDTOTipo.NUMERIC:
      return Datatype.Number;
    case EnumTagSemanticoDTOTipo.TEXT:
      return Datatype.String;
    case EnumTagSemanticoDTOTipo.IMAGE:
      return Datatype.Image;
    default:
      assertNever(semanticTagType);
  }
}

export interface ISemanticTagOptionProps {
  semanticTag: TagSemanticoDTO;
}

/**
 * Opzione della select che renderizza il semantic tag con l'icona del tipo di dato.
 */
export function SemanticTagBadge(props: ISemanticTagOptionProps) {
  const { semanticTag } = props;

  const tagType = mapSemanticTagType(semanticTag.tipo);

  const Icon = useMemo(() => {
    if (!tagType) return <BorderOutlined />;
    if (tagType === 'geometry') return <PushpinOutlined />;
    return <DatatypeIcon type={tagType} />;
  }, [tagType]);

  return (
    <SemanticTagBadgeSpace>
      {Icon}
      <span>
        {semanticTag.titolo ?? semanticTag.nome ?? semanticTag.id ?? 'N/A'}
      </span>
    </SemanticTagBadgeSpace>
  );
}
